export default class ErrorReporter {
    static report(error, extraInfo = {}) {
        try {
            $.ajax({
                url: `${window.env.publicApiUrl}/frontend-report/error-log`,
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({
                    errorMessage: error?.message || (typeof error === 'object' ? JSON.stringify(error) : String(error)),
                    stack: error?.stack || null,
                    url: window.location.href,
                    extraInfo: this.sanitizeExtraInfo(extraInfo),
                }),
                processData: false,
                timeout: 2000,
            });
        } catch {
            // fail silently
        }
    }

    static sanitizeExtraInfo(extraInfo) {
        try {
            return JSON.parse(JSON.stringify(extraInfo));
        } catch {
            return { error: 'Context could not be serialized' };
        }
    }
}
